import React, { useContext } from "react";

import StockpilesTable from "../stockpiles-table/stockpiles-table.component";
import OutputTable from "../output-table/output-table.component";
import { RADIO_SWITCHER_VALUES } from "../../constants";
import { MatchContext } from "../../context";
import EquipmentTable from "../equipment-table/equipment-table.component";

const TablesContainer = ({
  handleChangeTableInputs,
  handleChangeTableWeights,
}): JSX.Element => {
  const { state } = useContext(MatchContext);

  return (
    <React.Fragment>
      <div className="content">
        {state.ioSwitcherValue === RADIO_SWITCHER_VALUES.INPUT ? (
          <StockpilesTable
            handleChangeTableInputs={handleChangeTableInputs}
            handleChangeTableWeights={handleChangeTableWeights}
          />
        ) : state.ioSwitcherValue === RADIO_SWITCHER_VALUES.OUTPUT ? (
          <OutputTable />
        ) : (
          <EquipmentTable />
        )}
      </div>
    </React.Fragment>
  );
};

export default TablesContainer;
